import React, { useEffect, useRef, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import "./Sessions.css";
import AddMoreSessions from "./AddMoreSessions/AddMoreSessions";
import UpdateExistingSessions from "./UpdateExistingSessions/UpdateExistingSessions";
import DeleteIcon from "@mui/icons-material/Delete";
import ChatIcon from "@mui/icons-material/Chat";
import ShareIcon from "@mui/icons-material/Share";
import EditIcon from "@mui/icons-material/Edit";
import CodeQueueSpinner, { handleError } from "../../../Utils";
import DeleteSession from "./DeleteSessions/DeleteSession";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { getMentorSessions } from "../../../ApiServices/ApiServices";

export const getSessionDetails = async (
  email,
  setSessionsDetails,
  setLoading
) => {
  try {
    const response = await getMentorSessions(email);
    setSessionsDetails(response.sessions);
  } catch (error) {
    return handleError(error?.response?.data?.message);
  } finally {
    setLoading(false);
  }
};

const Sessions = () => {
  const [isAddSessionsVisible, setIsAddSessionsVisible] = useState(false);
  const [isUpdateSessionsVisible, setIsUpdateSessionsVisible] = useState(false);
  const [isDeleteSessionVisible, setIsDeleteSessionVisible] = useState(false);
  const email = getEmail();
  const [sessionsDetails, setSessionsDetails] = useState([]);
  const [index, setIndex] = useState(null);
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [duration, setDuration] = useState("");
  const [amount, setAmount] = useState("");
  const calledOnce = useRef(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Dashboard - Sessions";
    if (calledOnce.current) return; // Exit if already called
    calledOnce.current = true;

    if (email) {
      getSessionDetails(email, setSessionsDetails, setLoading);
    }
  }, [email]);
  const showUpdatePopUp = (index, title, type, duration, amount) => {
    setIndex(index);
    setTitle(title);
    setType(type)
    setDuration(duration);
    setAmount(amount);
    setIsUpdateSessionsVisible(!isUpdateSessionsVisible);
  };
  const showDeletePopUp = (index) => {
    setIndex(index);
    setIsDeleteSessionVisible(!isDeleteSessionVisible);
  };
  if (loading)
    return (
      <p className="flex justify-center items-center h-full">
        <CodeQueueSpinner />
      </p>
    );
  return (
    <div className="mentor-pricing flex">
      {sessionsDetails.map((item, index) => {
        let IconComponent = CalendarMonthIcon;
        let planText = `${item?.duration} mins`;
        let typeLabel = "Video Meeting";

        if (item?.type === "DM") {
          IconComponent = ChatIcon;
          planText = "Reply in two days";
          typeLabel = "DM";
        } else if (item?.type === "Referral") {
          IconComponent = ShareIcon;
          planText = "Reply in two days";
          typeLabel = "Referral";
        }

        return (
          <div className="mentor-pricing-card flex-col" key={index}>
            <div className="mentor-pricing-type delete-sessions flex">
              <span>{item?.title}</span>{" "}
              <span className="delete-icon">
                <DeleteIcon onClick={() => showDeletePopUp(index)} />
                <EditIcon
                  className="edit-delete"
                  onClick={() =>
                    showUpdatePopUp(
                      index,
                      item?.title,
                      item?.type,
                      item?.duration,
                      item?.amount
                    )
                  }
                />
              </span>
            </div>
            <div className="mentor-pricing-price flex">
              <div className="flex">
                <IconComponent className="icon" />
                <div className="video-meeting">
                  <div className="time">{planText}</div>
                  <div>{typeLabel}</div>
                </div>
              </div>
              <div className="price-value">
                ₹{item?.amount}
                <ArrowForwardIcon />
              </div>
            </div>
          </div>
        );
      })}
      <div
        className="mentor-pricing-card add-more-btn"
        onClick={setIsAddSessionsVisible}
      >
        <span>Add More</span>
        <span>
          <AddCircleIcon />
        </span>
      </div>
      <AddMoreSessions
        isVisible={isAddSessionsVisible}
        setIsVisible={setIsAddSessionsVisible}
        setSessionsDetails={setSessionsDetails}
        setLoading={setLoading}
      />
      <UpdateExistingSessions
        isVisible={isUpdateSessionsVisible}
        setIsVisible={setIsUpdateSessionsVisible}
        index={index}
        title={title}
        setTitle={setTitle}
        type={type}
        setType={setType}
        duration={duration}
        setDuration={setDuration}
        amount={amount}
        setAmount={setAmount}
        setSessionsDetails={setSessionsDetails}
        setLoading={setLoading}
      />
      {isDeleteSessionVisible && (
        <DeleteSession
          email={email}
          index={index}
          isVisible={isDeleteSessionVisible}
          setIsVisible={setIsDeleteSessionVisible}
          setSessionsDetails={setSessionsDetails}
          setLoading={setLoading}
        />
      )}
    </div>
  );
};

export default Sessions;
